export var CallableStyleElements;
(function (CallableStyleElements) {
    CallableStyleElements["XLabel"] = "XLabel";
    CallableStyleElements["YLabel"] = "YLabel";
})(CallableStyleElements || (CallableStyleElements = {}));
export var GenericStyleElements;
(function (GenericStyleElements) {
    GenericStyleElements["Root"] = "Root";
})(GenericStyleElements || (GenericStyleElements = {}));
export var DEFAULT_INTERVAL = 1;
